import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { useSelector, useDispatch } from "react-redux";
import { RootStateOrAny } from "react-redux";
import styles from "./styles.module.css";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import ImageComponent from "../ImageComponent";
import zupeeLogo from "../../assets/zupee-icon.svg";
import { useConfigStore } from "../../storage/configState";
import { GoogleLogin } from "@react-oauth/google";
import {
  GOOGLE_LOGIN_KEY,
  PARTNER_ID_KEY,
} from "../../appConstants/AppConstant";
import { hideGoogleLoginModal } from "../../store/actions/actions";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const GoogleLoginModal = () => {
  const { t } = useTranslation();
  const location = useLocation();
  // const {preSignupConfig} = useConfigStore.getState();
  // const {loginSkipConfig} = preSignupConfig || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { showGoogleLoginModal } = useSelector(
    (state: RootStateOrAny) => state.appReducer
  );
  const { preSignupConfig } = useConfigStore();
  const partnerImageUrl =
    preSignupConfig?.pwaConfig?.partnerSignupScreenImageUrl || zupeeLogo;

  const { loginSkipConfig } = preSignupConfig || {};
  const { enabled, allowedEmails } = loginSkipConfig || {};

  useEffect(() => {
    // Only show modal if:
    // 1. Not on home page
    // 2. showGoogleLoginModal is true
    // 3. loginSkipConfig is enabled
    setIsModalOpen(
      location.pathname !== "/" && showGoogleLoginModal && enabled
    );
  }, [showGoogleLoginModal, location.pathname, enabled]);

  const handleGoogleLogin = (credentialResponse: any) => {
    const token = credentialResponse?.credential;

    // Decode the JWT token to get user information
    const decodedToken = JSON.parse(atob(token.split(".")[1]));
    const userEmail = decodedToken.email;

    if (enabled && allowedEmails?.includes(userEmail)) {
      // Email is in allowed list
      const partnerId = localStorage.getItem(PARTNER_ID_KEY);
      sessionStorage.setItem(GOOGLE_LOGIN_KEY, token);
      sessionStorage.setItem(PARTNER_ID_KEY, partnerId || "");
      toast.success("Google authentication successful");
      dispatch(hideGoogleLoginModal());
    } else {
      // Email not in allowed list
      toast.error("Unauthorized email");
    }
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      className={styles.modalContainer}
      overlayClassName={styles.overlay}
      modalContentClassName={styles.modalContent}
      closeOnOverlayClick={false}
    >
      <div className={styles.contentBox}>
        {/* <div className={styles.crossBtn} onClick={() => setIsModalOpen(false)}>
          &#10005;
        </div> */}

        <div className={styles.partnerImage}>
          <ImageComponent src={partnerImageUrl} alt="brand logo" />
        </div>

        <div className={clsx(styles.pageHeading, "fontSizeSm fontWeightBold")}>
          {t("continueWithGoogle")}
        </div>
        <div className={styles.googleLoginButton}>
          <GoogleLogin
            type="standard"
            logo_alignment="center"
            shape="circle"
            text="signin_with"
            size="large"
            width="220"
            onSuccess={handleGoogleLogin}
            onError={() => {
              console.log("Login Failed");
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default GoogleLoginModal;
